import React, { useState, useEffect } from "react";
import "./Login.css";
import banner_img from "../../../images/banner-picture.png";
import login_logo from "../../../images/loginlogo.png";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { InputLabel, Input, InputAdornment, IconButton } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { Button } from "@mui/material";
import { Provider, useDispatch, useSelector } from "react-redux";
import { userLoginApi } from "../../../Services/Login/LoginApi/loginApi";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CommunityOwner, HomeOwner, SuperAdmin } from "../../../Utils/Constant";
import chevronleft from "../../../images/chevronleft.svg";
import owl_logo from "../../../images/HOA Owl Logo.svg";


function LoginComponent() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false); // Prevent multiple submissions
  const [showPassword, setShowPassword] = useState(false);
  const [rememberPassword, setRememberPassword] = useState(false);

  useEffect(() => {
    const accessToken = localStorage.getItem("access_token");
    const userType = localStorage.getItem("user_type");

    if (accessToken && userType) {
      switch (userType) {
        case CommunityOwner:
          navigate("/");
          break;
        // case SuperAdmin:
        //   navigate("/super-admin/dashboard");
        //   break;
        case HomeOwner:
          navigate("/home-owner-admin/dashboard");
          break;
        default:
          break;
      }
    }
  }, [navigate]);

  useEffect(() => {
    // Load saved password from local storage
    const savedPassword = localStorage.getItem("password");
    const savedEmail = localStorage.getItem("email");
    if (savedPassword && savedEmail) {
      setPassword(savedPassword);
      setEmail(savedEmail);
      setRememberPassword(true);
    }
  }, []);

  const handleRememberChange = (e) => {
    setRememberPassword(e.target.checked);
  };

  // Handler to toggle password visibility
  const handleClickShowPassword = () => {
    setShowPassword((prevState) => !prevState);
  };

  // Prevent default behavior for mouse down event
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };

  // Validation function
  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!email) {
      formErrors.email = "Email is required.";
      isValid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      formErrors.email = "Invalid email format.";
      isValid = false;
    }

    if (!password) {
      formErrors.password = "Password is required.";
      isValid = false;
    } else if (password.length < 6) {
      formErrors.password = "Password must be at least 6 characters long.";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  }; // Closing brace added here

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
    if (errors.email) {
      setErrors((prevErrors) => ({ ...prevErrors, email: "" }));
    }
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    if (errors.password) {
      setErrors((prevErrors) => ({ ...prevErrors, password: "" }));
    }
  };

  // Login API call
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return; // Prevent additional clicks
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true); // Lock the button

    localStorage.setItem("email", email);

    try {
      const response = await dispatch(
        userLoginApi({ email, password })
      ).unwrap();

  
      
      if (response?.status === 400){
        toast.error("Invalid Credentials!");
      }

      if (response?.status === 200) {
        localStorage.setItem("accessToken", response.data.token.access);
        // localStorage.setItem("email",response.data.token.email);
       

        if (response.data?.user_type === Provider) {
     

          toast.success("SuperAdmin login is not allowed.!");
          return; // Exit the function to stop further execution
        } else {
          // Proceed with storing tokens and user info in localStorage
          localStorage.setItem("access_token", response.token?.access);
          localStorage.setItem("user_type", response.data?.user_type);
          localStorage.setItem("user_id", response.data?.user_id);
          localStorage.setItem("user_first_name", response.data?.first_name);
          localStorage.setItem("user_last_name", response.data?.last_name);
         
          setTimeout(() => {
            navigate("super-admin/dashboard");
          }, 100);
        }
      }
    }catch (err) {
      console.error("Login error:", err); // Log the full error object

      if (err?.response) {
        console.error("Error Response Data:", err.response.data);
        const errorMessage = err.response?.data?.message || "Invalid credentials!";
        toast.error(errorMessage); // Display error message from API
      } else {
        toast.error("Login failed: Something went wrong. Please try again!");
      }
    }
     finally {
      setIsSubmitting(false); // Unlock the button
      setEmail(""); // Clear email input
      setPassword(""); // Clear password input
    }
  };

  const handleSignuproute = () => {
    navigate("/signupone");
  };

  // const handleBackClick = () => {
  //   navigate("/");
  // };

  const label = { inputProps: { "aria-label": "Checkbox demo" } };

  return (
    <>
      <section className="login-page-one login-box">
        <div className="container-fluid p-0 m-0">
          <div className="loginpage">
            <div className="login-cols-block">
              <div className="login-right-block mb-5 desktop-view">
                <div className="login-logoimg text-center">
                  <Link to="/">
                    <img
                      src={owl_logo}
                      alt="login-logo"
                      className="login_logo_img"
                    />
                  </Link>
                </div>
                {/* <div className="back-btn">
                  <a href="javascript:void(0)" onClick={handleBackClick}>
                    <img
                      src={chevronleft}
                      alt="chevron-left"
                      class="left-icon"
                    ></img>
                    Back
                  </a>
                </div> */}
              </div>
              <div className="login-page-area">
                <div className="login-information log-in">
                  {/* <h1 className="text-center">Log In</h1> */}
                  <div className="form-login text-left">
                    <div className="mb-4">
                      <InputLabel htmlFor="standard-adornment-email">
                        Email <span>*</span>
                      </InputLabel>
                      <Input
                        className="email-input-box"
                        id="standard-adornment-email"
                        type="email"
                        placeholder="Email"
                        onChange={handleEmailChange}
                        value={email}
                        onKeyDown={handleKeyDown}
                      />
                      {errors.email && (
                        <p className="error-text">{errors.email}</p>
                      )}
                    </div>
                    <div className="mb-4">
                      <InputLabel htmlFor="standard-adornment-password">
                        Password <span>*</span>
                      </InputLabel>
                      <Input
                        className="password-input-box"
                        id="standard-adornment-password"
                        placeholder="Password"
                        type={showPassword ? "text" : "password"}
                        onChange={handlePasswordChange}
                        value={password}
                        onKeyDown={handleKeyDown}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label={
                                showPassword
                                  ? "hide the password"
                                  : "display the password"
                              }
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                      {errors.password && (
                        <p className="error-text">{errors.password}</p>
                      )}
                    </div>
                    <div className="mb-4 checkbox d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        {/* <div>
                          <Checkbox
                            {...label}
                            checked={rememberPassword}
                            onChange={handleRememberChange}
                            className="check-box"
                          />
                        </div> */}
                        {/* <span className="password-text">Remember Password</span> */}
                      </div>
                      <div className="forgot-pw">
                        <Link to="/forgot-password">Forgot Password</Link>
                      </div>
                    </div>
                    <div className="btn-orange">
                      <Button onClick={handleSubmit} disabled={isSubmitting}>
                        {isSubmitting ? "Submitting..." : "Sign In"}
                      </Button>
                    </div>
                    {/* <div className="lower-signup-text text-center">
                      <p>
                        Don&apos;t have an account?{" "}
                        <a href="" onClick={handleSignuproute}>
                          Sign Up
                        </a>
                      </p>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
    </>
  );
}

export default LoginComponent;
